export default __webpack_public_path__ + "static/media/Wildguard Girdle.cfd042a6.jpg";